import { useEffect, useRef, useState } from 'react';
import { crearTabla, dividirLista, dividirListaNueva,  esformatoEmail, formatearDecimal, formatearFecha, guardarDatoLocal, isFlagUpdate, openInNewTab, operacionFechas, presentarError, presentarLog, recuperarDatoLocal, registrarLogEventos, reportarError, setFlagUpdate, showMensajePantalla, superaTiempoActualizacion, superaTiempoDefinido, valorNumero,  } from '../helpers/funciones';
import { useModal } from '../helpers/useModal';

import { requestPermission } from '../firebase';


import {estilosSelect} from '../estilos/estilosSelect'

import Select from "react-select";

import { getDatos } from '../gestionDatos/getDatos';

import Loader from "../recVisual/Loader";
import MenuFlotante from '../recVisual/MenuFlotante';
import Modal from '../recVisual/Modal';

import "../estilos/CT_Contenedor.css";
import "../estilos/IM_Imagenes.css";
import "../estilos/TX_Textos.css";
import "../estilos/BF_BordesFondos.css";
import "../estilos/IP_Inputs.css";



import ic_logo_mg from '../recGraficos/ic_logo_mg.png';
import ic_menu from '../recGraficos/ic_menu.png';
import ic_jugadorsinimagen from '../recGraficos/ic_jugadorsinimagen_blanco.png';
import ic_jugadorsinimagen_gris from '../recGraficos/ic_jugadorsinimagen.png';
import ic_mi_informacion from '../recGraficos/ic_mi_informacion.png';
import ic_salir_negro from '../recGraficos/ic_salir_negro.png';
import ic_cobros_recibir from '../recGraficos/ic_cobros_recibir.png';
import ic_sitio_web from '../recGraficos/ic_sitio_web.png';
import ic_partido from '../recGraficos/ic_partido.png';
import ic_partido_verde from '../recGraficos/ic_partido_verde.png';
import ic_partido_accent from '../recGraficos/ic_partido_accent.png';
import ic_balon_gol from '../recGraficos/ic_balon_gol.png';
import ic_nuevo_primary from '../recGraficos/ic_nuevo_primary.png';
import ic_torneo from '../recGraficos/ic_torneo.png';
import ic_torneo_accent from '../recGraficos/ic_torneo_accent.png';
import ic_torneo_gris_w from '../recGraficos/ic_torneo_gris_w.png';
import ic_informacion_blanco from '../recGraficos/ic_informacion_blanco.png';
import ic_informacion_accent from '../recGraficos/ic_informacion_accent.png';
import ic_escudo_base_gris from '../recGraficos/ic_escudo_base_gris.png';
import ic_escudo_base2_w from '../recGraficos/ic_escudo_base2_w.png';
import ic_manual_primary from '../recGraficos/ic_manual_primary.png';
import ic_manual_blanco from '../recGraficos/ic_manual_blanco.png';
import ic_llamada from '../recGraficos/ic_llamada.png';
import ic_whatsapp from '../recGraficos/ic_whatsapp.png';
import ic_email from '../recGraficos/ic_email.png';
import ic_mensaje_blanco from '../recGraficos/ic_mensaje_blanco.png';
import ic_mensaje_negro from '../recGraficos/ic_mensaje_negro.png';
import ic_tareas from '../recGraficos/ic_tareas.png';
import ic_estrella from '../recGraficos/ic_estrella.png';
import ic_sedes from '../recGraficos/ic_sedes.png';
import ic_silbato from '../recGraficos/ic_silbato.png';
import ic_programar from '../recGraficos/ic_programar.png';
import ic_jugador from '../recGraficos/ic_jugador.png';
import ic_planilla from '../recGraficos/ic_planilla.png';
import ic_ubicacion from '../recGraficos/ic_ubicacion.png';
import ic_gestion_recursos from '../recGraficos/ic_gestion_recursos.png';
import ic_empresa from '../recGraficos/ic_empresa.png';
import ic_transparente from '../recGraficos/ic_transparente.png';
import ic_sombrero from '../recGraficos/ic_sombrero.png';
import ic_configura_gris from '../recGraficos/ic_configura_gris.png';
import ic_estadisticas from '../recGraficos/ic_estadisticas.png';
import ic_tarjeta_dobleamarilla from '../recGraficos/ic_tarjeta_dobleamarilla.png';
import ic_responder_gris from '../recGraficos/ic_responder_gris.png';
import ic_calendario_gris from '../recGraficos/ic_calendario_gris.png';
import ic_enviarinformacion from '../recGraficos/ic_enviarinformacion.png';

import MenuLateral from '../recVisual/MenuLateral';
import { listaIconoDosItems } from '../recVisual/listaDesplegable';
import DinamicoPartidosProgramados from '../gestionVisual/DinamicoPartidosProgramados';
import { C_colorAccent, C_uniformeGrisOscuro,  C_uniformeBlanco,  C_colorPrimary, ID_MODULO_BASE, ID_MODULO_DETALLE_TORNEO, ID_MODULO_PRINCIPAL_JUGADOR, ID_MODULO_INFO_JUGADOR, ID_MODULO_GESTION_MICUENTA, C_uniformeVerdeClaro, C_uniformeAzulClaro, C_uniformeNegro, SEPARADOR_PARAMETROS_BD, C_colorPrimaryDark, ID_MODULO_INFO_MENSAJES, ID_MODULO_PRINCIPAL_ADMIN, ID_MODULO_DETALLE_PARTIDO, ID_MODULO_ADMIN_TORNEO, ID_MODULO_ADMIN_CONFIGURACION } from '../constantes/generales';
import ShowError from '../recVisual/ShowError';
import Stars from '../recVisual/Stars';
import { callUrl } from '../gestionDatos/callUrl';
import ContactoMG from '../recVisual/ContactoMG';
import DinamicoElementosTorneo from '../gestionVisual/DinamicoElementosTorneo';
import Template_lista_roles from '../gestionVisual/Template_lista_roles';



let ruta=recuperarDatoLocal("rutaRecursos");
const nomClase="Principal_Admin_WB";
const idModulo=ID_MODULO_PRINCIPAL_ADMIN;


let idUser="";
let tipoUser="";


let paramsAjustado="";
let paramsBase="";


let idSede = "";

let ventanaMensaje;

let numTorneoSel=0;

let tienePublicidad=false;
let msjNoLeidos=0; 
let tieneRoles=false;

let infoUsuarioO = [];
let infoSedesO = [];

let esMayorHoy=false;

let matrizCampos=[
    {id: "NOMBRE",  idx: 0, valor: "", ultValor:"", error: "Ingrese su nombre"},
    {id: "CORREO",  idx: 1, valor: "", ultValor:"", error: "Ingrese un correo válido"},
    {id: "PAIS",  idx: 2, valor: "", ultValor:"", error: "Seleccione el país de contacto"},
    {id: "TELEFONO",  idx: 3, valor: "", ultValor:"", error: "Ingrese un teléfono válido"},
    {id: "ASUNTO",  idx: 4, valor: "", ultValor:"", error: "Seleccione el asunto del contacto"},
    {id: "MENSAJE",  idx: 5, valor: "", ultValor:"", error: "Ingrese su mensaje"}
];

let paises=[
    {value:"0", label:"Selecciona tú País", texto2:""},
    {value:"57", label:"Colombia", texto2:""},
    {value:"54", label:"Argentina", texto2:""},
    {value:"56", label:"Chile", texto2:""},
    {value:"593", label:"Ecuador", texto2:""},
    {value:"1", label:"Estados Unidos", texto2:""},
    {value:"52", label:"México", texto2:""},
    {value:"51", label:"Perú", texto2:""},
    {value:"-1", label:"Otro", texto2:""}
];

let asuntos=[
    {value:"0", label:"Selecciona tú asunto", texto2:""},
    {value:"1", label:"Pregunta sobre la funcionalidad", texto2:""},
    {value:"2", label:"Soporte Técnico", texto2:""},
    {value:"3", label:"Reportar un problema", texto2:""},
    {value:"4", label:"Sugerencia, comentario, felicitación", texto2:""},
    {value:"5", label:"Otro asunto", texto2:""}
];


var infoAdminO = [];
var infoAdmin = [];
function crearInfoAdmin(datos){   
    const nomFuncion="crearInfoAdmin";

    try{
        let admin = {
            idusuario:"",
            idrol:"",
            idasociado:"",
            nombreRol:"",
            idempresa:"",
            nombreEmpresa:"",
            idsede:"",
            nombreSede:"",
            activo:"",
            nombreUsuario:"",
            foto:"",
            tipo_arbitros:"",
            tipo_registroinfo:""
        }
    
        infoAdminO = [];
        infoAdmin = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , admin);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idusuario=datos[i][j];
                if(j===1) registro.idrol=datos[i][j];
                if(j===2) registro.idasociado=datos[i][j];
                if(j===3) registro.nombreRol=datos[i][j];
                if(j===4) registro.idempresa=datos[i][j];
                if(j===5) registro.nombreEmpresa=datos[i][j];
                if(j===6) registro.idsede=datos[i][j];
                if(j===7) registro.nombreSede=datos[i][j];
                if(j===8) registro.activo=datos[i][j];
                if(j===9) registro.nombreUsuario=datos[i][j];
                if(j===10) registro.foto=datos[i][j];
                if(j===11) registro.tipo_arbitros=datos[i][j];
                if(j===12) registro.tipo_registroinfo=datos[i][j];

            }

            infoAdminO.push(registro);
            infoAdmin.push(datos[i]);
        
        }



    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }
    
}

var infoPartidosO = [];
var infoPartidos = [];
function crearInfoPartidos(datos){   
    const nomFuncion="crearInfoPartidos";

    try{
        let partido = {
            index:0,
            idtorneo:"",
            sinInfo0:"",
            idpartido:"",
            numeroJornada:"",
            numCancha:"",
            idequipo1:"",
            nomCortoEq1:"",
            imgEscudoEq1:"",
            idequipo2:"",
            nomCortoEq2:"",
            imgEscudoEq2:"",
            sinInfo1:"",
            sinInfo2:"",
            fechaPartido:"",
            horaPartido:"",
            golesEq1:"",
            golesEq2:"",
            parte:"",
            tiempo:"",
            minutospartido:"",
            idestado:"",
            nomEstado:"",
            fechaActual:"",
            horaActual:"",
            idjornada:"",
            estadotiempo:"",
            fechainiciotiempo:"",
            sinInfo3:"",
            sinInfo4:"",
            tipo_torneo:"",
            tipo_registroinfo:"",
            activo:"",
            idsede:"",
            sinInfo5:"",
            nombreCancha:"",
            imgArbitro1:"",
            penaltisEq1:"",
            penaltisEq2:"",
            idarbitro1:"",
            nomArbitro1:""
        }        
    
        infoPartidosO = [];
        infoPartidos = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , partido);
            registro.index=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idtorneo=datos[i][j];
                if(j===1) registro.sinInfo0=datos[i][j];
                if(j===2) registro.idpartido=datos[i][j];
                if(j===3) registro.numeroJornada=datos[i][j];
                if(j===4) registro.numCancha=datos[i][j];
                if(j===5) registro.idequipo1=datos[i][j];
                if(j===6) registro.nomCortoEq1=datos[i][j];
                if(j===7) registro.imgEscudoEq1=datos[i][j];
                if(j===8) registro.idequipo2=datos[i][j];
                if(j===9) registro.nomCortoEq2=datos[i][j];
                if(j===10) registro.imgEscudoEq2=datos[i][j];
                if(j===11) registro.sinInfo1=datos[i][j];
                if(j===12) registro.sinInfo2=datos[i][j];
                if(j===13) registro.fechaPartido=datos[i][j];
                if(j===14) registro.horaPartido=datos[i][j];
                if(j===15) registro.golesEq1=datos[i][j];
                if(j===16) registro.golesEq2=datos[i][j];
                if(j===17) registro.parte=datos[i][j];
                if(j===18) registro.tiempo=datos[i][j];
                if(j===19) registro.minutospartido=datos[i][j];
                if(j===20) registro.idestado=datos[i][j];
                if(j===21) registro.nomEstado=datos[i][j];
                if(j===22) registro.fechaActual=datos[i][j];
                if(j===23) registro.horaActual=datos[i][j];
                if(j===24) registro.idjornada=datos[i][j];
                if(j===25) registro.estadotiempo=datos[i][j];
                if(j===26) registro.fechainiciotiempo=datos[i][j];
                if(j===27) registro.sinInfo3=datos[i][j];
                if(j===28) registro.sinInfo4=datos[i][j];
                if(j===29) registro.tipo_torneo=datos[i][j];
                if(j===30) registro.tipo_registroinfo=datos[i][j];
                if(j===31) registro.activo=datos[i][j];
                if(j===32) registro.idsede=datos[i][j];
                if(j===33) registro.sinInfo5=datos[i][j];
                if(j===34) registro.nombreCancha=datos[i][j];
                if(j===35) registro.imgArbitro1=datos[i][j];
                if(j===36) registro.penaltisEq1=datos[i][j];
                if(j===37) registro.penaltisEq2=datos[i][j];
                if(j===38) registro.idarbitro1=datos[i][j];
                if(j===39) registro.nomArbitro1=datos[i][j];
            }


            infoPartidosO.push(registro);
            infoPartidos.push(datos[i]);

        }

        

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }
    
}

var infoTorneosO = [];
var infoTorneos = [];
function crearInfoTorneos(datos){   
    const nomFuncion="crearInfoTorneos";

    try{
        let torneo = {
            index:0,
            idtorneo:"",
            escudo:"",
            nombre:"",
            activo:"",
            sinInfo1:"",
            idsede:"",
            idarbitro:"",
            tipo_arbitros:"",
            tipo_registroinfo:""
        }
    
        infoTorneosO = [];
        infoTorneos = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , torneo);
            registro.index=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idtorneo=datos[i][j];
                if(j===1) registro.escudo=datos[i][j];
                if(j===2) registro.nombre=datos[i][j];
                if(j===3) registro.activo=datos[i][j];
                if(j===4) registro.sinInfo1=datos[i][j];
                if(j===5) registro.idsede=datos[i][j];
                if(j===6) registro.idarbitro=datos[i][j];
                if(j===7) registro.tipo_arbitros=datos[i][j];
                if(j===8) registro.tipo_registroinfo=datos[i][j];
            }

            infoTorneosO.push(registro);
            infoTorneos.push(datos[i]);
                       
            
        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }
    
}

let calificacion = {
            idsede:"",
            c_arbitro:"0",
            c1_arbitro:"0",
            c2_arbitro:"0",
            c3_arbitro:"0",
            c_sede:"0",
            c1_sede:"0",
            c2_sede:"0",
            num_evaluaciones:"0",
            num_partidos:"0"
        }
var infoCalificacionesO = [];
var infoCalificaciones = [];
function crearInfoCalificaciones(datos){   
    const nomFuncion="crearInfoCalificaciones";

    try{   

        
    
        infoCalificacionesO = [];
        infoCalificaciones = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , calificacion);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idsede=datos[i][j];
                if(j===1) registro.c_arbitro=datos[i][j];
                if(j===2) registro.c1_arbitro=datos[i][j];
                if(j===3) registro.c2_arbitro=datos[i][j];
                if(j===4) registro.c3_arbitro=datos[i][j];
                if(j===5) registro.c_sede=datos[i][j];
                if(j===6) registro.c1_sede=datos[i][j];
                if(j===7) registro.c2_sede=datos[i][j];
                if(j===8) registro.num_evaluaciones=datos[i][j];
                if(j===9) registro.num_partidos=datos[i][j];
            }

            infoCalificacionesO.push(registro);
            infoCalificaciones.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }
    
}

let cifra = {
            idsede:"",
            numTorneos:"",
            numEquipos:"",
            numJugadores:"",
            numArbitros:"",
            numCanchas:"",
            numPartidos:""
        }
var infoCifrasSedeO = [];
var infoCifrasSede = [];
function crearInfoCifrasSede(datos){   
    const nomFuncion="crearInfoCifrasSede";

    try{      

        
    
        infoCifrasSedeO = [];
        infoCifrasSede = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , cifra);
            registro.indice=i;
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idsede=datos[i][j];
                if(j===1) registro.numTorneos=datos[i][j];
                if(j===2) registro.numEquipos=datos[i][j];
                if(j===3) registro.numJugadores=datos[i][j];
                if(j===4) registro.numArbitros=datos[i][j];
                if(j===5) registro.numCanchas=datos[i][j];
                if(j===6) registro.numPartidos=datos[i][j];
            }

            infoCifrasSedeO.push(registro);
            infoCifrasSede.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }
    
}


function crearInfoBaseMensajes(datos){   
    const nomFuncion="crearInfoBaseMensajes";

    try{
        msjNoLeidos=0;
        tienePublicidad=false; 

        if(datos.length>0){
            if(datos[0][0]!=="0") msjNoLeidos=valorNumero(datos[0][0]);
            if(datos[0][1]!=="0") tienePublicidad=true;
        }
    

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }
    
}

var infoMensajeO = [];
var infoMensaje = [];
function crearInfoMensaje(datos){   
    const nomFuncion="crearInfoMensaje";

    try{
        let mensaje = {
            idmensaje:"",
            titulo:"",
            textoini:"",
            imagen:"",
            textofin:"",
            link:"",
            textolink:""
        }
    
        infoMensajeO = [];
        infoMensaje = [];
    
        let i, j;
        for(i=0;i<datos.length;i++){
            let registro=Object.assign({} , mensaje);
            for(j=0;j<datos[i].length;j++){
                if(j===0) registro.idmensaje=datos[i][j];
                if(j===1) registro.titulo=datos[i][j];
                if(j===2) registro.textoini=datos[i][j];
                if(j===3) registro.imagen=datos[i][j];
                if(j===4) registro.textofin=datos[i][j];
                if(j===5) registro.link=datos[i][j];
                if(j===6) registro.textolink=datos[i][j]; 
            }

            infoMensajeO.push(registro);
            infoMensaje.push(datos[i]);

        }

    }catch(err){
        reportarError(nomClase, nomFuncion, "", err);
    }
    
}





const Principal_Admin= ({params="", definirModulo}) => {
    const [esError, setEsError] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showMensaje, setShowMensaje] = useState(false);

    const [arrCampos, setArrCampos] = useState(matrizCampos);  

    const [isOpenMenuFlotante, openMenuFlotante, closeMenuFlotante] = useModal(false);
    const [isOpenMenuLateral, openMenuLateral, closeMenuLateral] = useModal(false);
    const [isOpenPublicidad, openPublicidad, closePublicidad] = useModal(false);
    const [isOpenRoles, openRoles, closeRoles] = useModal(false);

    const [clickAceptarModal, setClickAceptarModal] = useState(false);
    const [msjModal, setMsjModal] = useState("");

    const [sedeSelUS, setSedeSelUS] = useState(0);
    const [selSedesUS, setSelSedesUS] = useState([]);

    const [datosMDContacto, setDatosMDContacto] = useState([]);
    const [acepto, setAcepto] = useState(false);

    const [showContactoMG, setShowContactoMG] = useState(false);

    const [msjNoLeidosUS, setMsjNoLeidosUS] = useState(0);


    const [nomUsuarioUS, setNomUsuarioUS] = useState("");
    const [fotoUsuarioUS, setFotoUsuarioUS] = useState(ic_jugadorsinimagen);
    const [nomEmpresaUS, setNomEmpresaUS] = useState("");
    const [nomSedeUS, setNomSedeUS] = useState("");
    const [pestanaSelUS, setPestanaSelUS] = useState(0);

    const [listaTorneosUS, setListaTorneosUS] = useState([]);
    const [listaPartidosUS, setListaPartidosUS] = useState([]);
    const [listaPanelControlUS, setListaPanelControlUS] = useState([]);

    const [listaRolesUser, setListaRolesUser] = useState([]);

    const [showInfoAdicionalUS, setInfoAdicionalUS] = useState(false);

    const [infoCampoSel, setInfoCampoSel] = useState("-1");
    const [irHastaHoy, setIrHastaHoy] = useState(true);

    
    useEffect(() => {
        const nomFuncion="useEffect";

        try{ 

            ruta=recuperarDatoLocal("rutaRecursos");
            idSede=recuperarDatoLocal("idSede");
            idUser=recuperarDatoLocal("idUser");
            guardarDatoLocal("tipoUser","administrador");
            tipoUser="administrador";
            let ultParametros=recuperarDatoLocal("ultParametros" + idModulo);
            //idTorneoNotificacion=recuperarDatoLocal("idTorneoNotificacion");
            //if(idTorneoNotificacion!=="") guardarDatoLocal("idTorneoNotificacion","");

    
                          

            paramsAjustado=params;  
            let pestana="0";

            if(params!==""){
                let actualizar=false;
                let info=dividirLista(params,"#",2);

                if(ultParametros!==info[0]) {
                    actualizar=true;
                    guardarDatoLocal("ultParametros" + idModulo,info[0]);
                }               

                if(info[0]!=="" && info[0]!==idUser){
                    actualizar=true;
                    idUser=info[0];
                }  

                if(info[1]!==""){
                    pestana=valorNumero(info[1]);
                    setPestanaSelUS(pestana);
                }

                paramsAjustado=idUser + "#" + pestana;

                if(!actualizar) {
                    actualizar= (isFlagUpdate() || superaTiempoActualizacion(idModulo));
                }
                

                let tRoles=recuperarDatoLocal("tieneRoles");
                if(tRoles==="1"){
                    tieneRoles=true;
                    infoUsuarioO=recuperarDatoLocal("infoUsuario");  
                    procesarInfoUsuario();
                    procesarListaRoles();
                }
                else {
                    tieneRoles=false;
                    infoSedesO=[];
                }
                
                paramsBase=paramsAjustado;
    
                //actualizar=true;
                if(actualizar){                   
                    BD_solicitarDatos("INFO_INICIAL",[]);
                }
                else{
                    presentarLog(nomClase + " - RECUPERA_DATOS"); 
                    let datosModulo=recuperarDatoLocal("datos" + idModulo);

                    if(datosModulo!==""){

                        crearInfoAdmin(crearTabla(datosModulo,"1"));
                        crearInfoPartidos(crearTabla(datosModulo,"2"));
                        crearInfoTorneos(crearTabla(datosModulo,"3"));
                        crearInfoCalificaciones(crearTabla(datosModulo,"4"));
                        crearInfoCifrasSede(crearTabla(datosModulo,"5"));  
                        crearInfoBaseMensajes(crearTabla(datosModulo,"6"));  
                        

                        if(infoSedesO.length===0){
                            if(infoAdminO.length>0){
                                infoSedesO.push([infoAdminO[0].idsede, infoAdminO[0].nombreEmpresa, infoAdminO[0].nombreSede, "57"]);
                  
                                setNomEmpresaUS(infoAdminO[0].nombreEmpresa);
                                setNomSedeUS(infoAdminO[0].nombreSede);

                                guardarDatoLocal("nomEmpresa",infoAdminO[0].nombreEmpresa);
                                guardarDatoLocal("nomSede",infoAdminO[0].nombreSede);
                                
                            }
                        }

                        
                        setNomUsuarioUS(infoAdminO[0].nombreUsuario);
                        if(infoAdminO[0].foto!=="") setFotoUsuarioUS(ruta + infoAdminO[0].foto);
                        setMsjNoLeidosUS(msjNoLeidos);

                        guardarDatoLocal("idUser",idUser);
                        //guardarDatoLocal("tipoUser",tipoUser);
                        guardarDatoLocal("idSede",idSede);
                        guardarDatoLocal("idAsociado","0");

                        guardarDatoLocal("nomUsuario",infoAdminO[0].nombreUsuario);
                        guardarDatoLocal("fotoUsuario",infoAdminO[0].foto);

                        cargarTorneos();
                        cargarPartidos();
                        cargarPanelControl();   

                    } else BD_solicitarDatos("INFO_INICIAL",[]);
                            
                } 
                
            }

            analizarNotificaciones();
    

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }     
        

    }, [params]);


    if(params==="") return null;

    var respuesta = {
        datos: "",
        exito: false,
        conectado: false,
        hayDatos: false,
        mensaje: ''
    }


    const BD_solicitarDatos = (tipoDatos, params) => {
        let nomFuncion="BD_solicitarDatos"; 

        try{
            let actualizar=true;
            let separador=SEPARADOR_PARAMETROS_BD;
            let SEP=SEPARADOR_PARAMETROS_BD;
            let paramQuery="";
            let tipoConsulta="";
            let funcion="";
            let consulta="";
            let zonaHoraria="0";
            let mostrarError=true;
            let mostrarProcesando=true;

            let codigoFinal="";
            
            if(actualizar){

                zonaHoraria="" + valorNumero(recuperarDatoLocal("zonahoraria"));
                
                if(tipoDatos==="INFO_INICIAL"){
                    tipoConsulta="consultarTabla";
                    funcion="getListasDetalleUsuario";
                    consulta="INFO_PANELCONTROL_ADMIN";
                    
                    idUser=recuperarDatoLocal("idUser");
                    paramQuery= idUser;
                } else if(tipoDatos==="ENVIAR_MENSAJE_CONTACTO"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarUsuario";
                    consulta="ENVIAR_MENSAJE_CONTACTO";
                    mostrarProcesando=false;
                    
                    /*let idSede=recuperarDatoLocal("idSede");
                    if(valorNumero(idSede)<=0) idSede="-1";
                    let nombre= formatearTexto(quitarCharEspeciales(arrCampos[0].valor),2);
                    let correo=arrCampos[1].valor.toLowerCase();
                    let txtPais=paises[posPaisSel].label;
                    let indicativo=paises[posPaisSel].value;
                    let telefono=arrCampos[3].valor;
                    let txtAsunto=asuntos[posAsuntoSel].label;
                    let mensaje=quitarCharEspeciales(arrCampos[5].valor);

                    paramQuery=  idSede + SEP + idUser + SEP + tipoUser + SEP + nombre + SEP + correo + SEP + txtPais + SEP + indicativo + SEP + telefono + SEP + txtAsunto + SEP + mensaje;
                    */

                    paramQuery=params;
                } else if(tipoDatos==="RECUPERAR_MENSAJE_PUBLICIDAD"){
                    tipoConsulta="consultarTabla";
                    funcion="getListaMensajes";
                    consulta="RECUPERAR_MENSAJE_PUBLICIDAD";
                    mostrarProcesando=false;
                    
                    idUser=recuperarDatoLocal("idUser");
                    paramQuery= idUser;
                } else if(tipoDatos==="ACTUALIZAR_LECTURA_MENSAJE"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarMensajes";
                    consulta="ACTUALIZAR_LECTURA_MENSAJE";
                    mostrarProcesando=false;
                    
                    let id_mensaje=infoMensajeO[0].idmensaje;
                    idSede=recuperarDatoLocal("idSede");
                    idUser=recuperarDatoLocal("idUser");

                    paramQuery= idSede + separador + id_mensaje + separador + idUser;
                } else if(tipoDatos==="GUARDAR_TOKEN"){
                    tipoConsulta="ejecutarSQL";
                    funcion="actualizarUsuario";
                    consulta="GUARDAR_TOKEN";
                    mostrarProcesando=false;
                    mostrarError=false;                    
                    
                    let tokenenviado = params[0];
                    let iduserguardado = params[1];
                    let origenToken = "WS";

                    paramQuery= tokenenviado + separador + iduserguardado + separador + origenToken;
                }    
                   
                
                if(mostrarProcesando) setLoading(true);

                getDatos()
                .get(tipoConsulta,funcion,consulta,paramQuery,zonaHoraria)
                .then((res) => {
                    respuesta=res;
                    if (respuesta.exito) {
                        if(tipoDatos==="INFO_INICIAL"){
                            presentarLog(nomClase + " - SOLICITA_DATOS"); 

                            guardarDatoLocal("ultAcceso" + idModulo,Date.now());
                            guardarDatoLocal("datos" + idModulo, respuesta.datos);                            

                            crearInfoAdmin(crearTabla(respuesta.datos,"1"));
                            crearInfoPartidos(crearTabla(respuesta.datos,"2"));
                            crearInfoTorneos(crearTabla(respuesta.datos,"3"));
                            crearInfoCalificaciones(crearTabla(respuesta.datos,"4"));
                            crearInfoCifrasSede(crearTabla(respuesta.datos,"5"));  
                            crearInfoBaseMensajes(crearTabla(respuesta.datos,"6"));  


                            if(infoSedesO.length===0){
                                    if(infoAdminO.length>0){
                                        infoSedesO.push([infoAdminO[0].idsede, infoAdminO[0].nombreEmpresa, infoAdminO[0].nombreSede, "57"]);
                  
                                        setNomEmpresaUS(infoAdminO[0].nombreEmpresa);
                                        setNomSedeUS(infoAdminO[0].nombreSede);

                                        guardarDatoLocal("nomEmpresa",infoAdminO[0].nombreEmpresa);
                                        guardarDatoLocal("nomSede",infoAdminO[0].nombreSede);
                                    }
                            }

                            
                            
                            guardarDatoLocal("idUser",idUser);
                            //guardarDatoLocal("tipoUser",tipoUser);
                            guardarDatoLocal("idSede",idSede);
                            guardarDatoLocal("idAsociado","0");

                            guardarDatoLocal("nomUsuario",infoAdminO[0].nombreUsuario);
                            guardarDatoLocal("fotoUsuario",infoAdminO[0].foto);                            

                            cargarTorneos();
                            cargarPartidos();
                            cargarPanelControl();   

                            //cargarListaTorneos();     
                            

                            setNomUsuarioUS(infoAdminO[0].nombreUsuario);
                            if(infoAdminO[0].foto!=="") setFotoUsuarioUS(ruta + infoAdminO[0].foto);
                            setMsjNoLeidosUS(msjNoLeidos);        
                            if(tienePublicidad) BD_solicitarDatos("RECUPERAR_MENSAJE_PUBLICIDAD",[]);
                            

                            registrarLogEventos(idModulo, "1", "1","0" );

                        } else if(tipoDatos==="ENVIAR_MENSAJE_CONTACTO"){
                            ventanaMensaje=showMensajePantalla("MENSAJE RECIBIDO","Gracias por comunicarte con MarcaGol. Muy pronto nos contactaremos contigo.",setShowMensaje,null,"EXITO","MEDIA");

                            try{
                                let retorno=dividirListaNueva(params,SEPARADOR_PARAMETROS_BD);

                                let nombre=retorno[3];
                                let telefono=retorno[7];

                                //let nombre=formatearTexto(quitarCharEspeciales(arrCampos[0].valor),2);
                                //let telefono=arrCampos[3].valor;
                                let msj="Nombre:" + nombre.replaceAll(" ","") + "Telefono:" + telefono.replaceAll(" ","");
                                let datos=[msj];
                                callUrl().get("CORREO_CONTACTO", datos);
                            }catch(e){}

                        } else if(tipoDatos==="RECUPERAR_MENSAJE_PUBLICIDAD"){

                            crearInfoMensaje(crearTabla(respuesta.datos,"1"));
                            
                            if(infoMensajeO.length>0){
                                openPublicidad();

                                BD_solicitarDatos("ACTUALIZAR_LECTURA_MENSAJE",[]);

                                if(msjNoLeidos>0){
                                    msjNoLeidos--;
                                    setMsjNoLeidosUS(msjNoLeidos);
                                } 
                                setFlagUpdate(true);
                            }                        

                        } else if(tipoDatos==="ACTUALIZAR_LECTURA_MENSAJE"){                            

                        } else if(tipoDatos==="GUARDAR_TOKEN"){
                            guardarDatoLocal("tokenenviado",params[0]);
                            guardarDatoLocal("iduserguardado",params[1]);

                            //ventanaMensaje=showMensajePantalla("TOKEN GUARDADO","El TOKEN de este equipo ha sido enviado al servidor con EXITO",setShowMensaje,null,"EXITO","MEDIA");

                        }                                                      
        
                    } else {
                        if(respuesta.conectado){
                            reportarError( nomClase, nomFuncion, respuesta.mensaje, "");
                            if(mostrarError) setEsError(1);
                        } 
                        else{    
                            presentarError(nomClase,nomFuncion,respuesta.mensaje,"");                        
                            setEsError(2);
                        }                        
                    }
        
                    setLoading(false);
                    
                });
            }
            
           

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }  

    const procesarInfoUsuario = () => {
        let nomFuncion="procesarInfoUsuario";

        try{
            infoSedesO=[];
            let tempSedesUS=[];

            const lista ={
                index:0,
                value:"",
                label:"",
                texto2:"",
                imagen:""
              }  

            let contador=0;
            let iBase=0;
            let tempSedeSel=0;

            if(infoUsuarioO.length>0){
                for(let i=0;i<infoUsuarioO.length;i++){
                            let tempSedes = ["","","",""]
                            if(infoUsuarioO[i].idrol==="2"){
                                tempSedes[0]=infoUsuarioO[i].idsede;
                                tempSedes[1]=infoUsuarioO[i].nombreEmpresa;
                                tempSedes[2]=infoUsuarioO[i].nombreSede;
                                tempSedes[3]=infoUsuarioO[i].indicativo;

                                infoSedesO.push(tempSedes);

                                if(infoUsuarioO[i].idsede===idSede){
                                    tempSedeSel=contador;    
                                    iBase=i;                        
                                }

                                let registro=Object.assign({} , lista);

                                registro.index=contador;
                                registro.value=infoUsuarioO[i].idsede;
                                registro.label=infoUsuarioO[i].nombreEmpresa;
                                registro.texto2="Sede: " + infoUsuarioO[i].nombreSede;
                                registro.imagen="";

                                tempSedesUS.push(registro);

                                contador++;
                            }
                            

                    }

                guardarDatoLocal("nomEmpresa",infoUsuarioO[iBase].nombreEmpresa);
                guardarDatoLocal("nomSede",infoUsuarioO[iBase].nombreSede);
                            
            }

            
            if(contador===0){
                let registro=Object.assign({} , lista);

                registro.index=contador;
                registro.value="-1";
                registro.label="Sin Sedes Activas";
                registro.texto2="";
                registro.imagen="";

                tempSedesUS.push(registro);
            }

            

            setSedeSelUS(tempSedeSel);
            setSelSedesUS(tempSedesUS);


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        } 

    }

    const procesarListaRoles = () => {
        let nomFuncion="procesarListaRoles";

        try{

            let roles=[];

            if(infoUsuarioO.length>0){

                let contRoles=0;                
                let i;
                let rolActual="";

                for(i=0;i<infoUsuarioO.length;i++){

                    let tempRol=[];
                    if(infoUsuarioO[i].nombreRol.toLowerCase()!=="administrador"){

                        if(rolActual!==(infoUsuarioO[i].idrol)){                            
                            roles.push([infoUsuarioO[i].nombreRol,infoUsuarioO[i].nombreEmpresa,infoUsuarioO[i].nombreSede,i]);
                            contRoles++;  
                            rolActual=infoUsuarioO[i].idrol;                        
                        }
                        else{
                            tieneRoles=true;

                            if(roles[contRoles-1][1]!==(infoUsuarioO[i].nombreEmpresa) && roles[contRoles-1][1]!==("Varias Empresas")){
                                let tempReg=roles[contRoles-1];

                                tempReg[1]="Varias Empresas";
                                tempReg[2]="Varias Sedes";

                                roles.splice(contRoles-1,1,tempReg);
                            }

                            if(roles[contRoles-1][2]!==(infoUsuarioO[i].nombreSede) && roles[contRoles-1][2]!==("Varias Sedes")){
                                let tempReg=roles[contRoles-1];

                                tempReg[2]="Varias Sedes";

                                roles.splice(contRoles-1,1,tempReg);
                            }
                        }

                    }

                }


                
            }

            setListaRolesUser(roles);


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    }


    const clickGenerico = (donde, params=null) => {
        let nomFuncion="clickGenerico"; 

        try{

            let titulo="";
            let mensaje="";
            let parametros="";
            //let params="";

            let tempArreglo;
            let listaFechas;
            let listaTorneos;
            let listaPartidos;

            let ingresar=true;
            let permiso = recuperarDatoLocal("tienePermisoNotificaciones");
            if(permiso===""){
                ingresar=false;
                requestPermission();
            }

            if(ingresar){
                switch(donde) {
                    case "CERRAR_SESION":
                        guardarDatoLocal("password","");   

                        guardarDatoLocal("idUser","");
                        guardarDatoLocal("tipoUser","");
                        guardarDatoLocal("idSede","");
                        guardarDatoLocal("idAsociado","");    

                        definirModulo(0, 0, "", ID_MODULO_BASE, ""); 
                         
                        break;                                        
                    case "CLICK_MENU_MIINFORMACION":
                        if(idUser!==""){
                            let parametros=idUser;
                            definirModulo(0, idModulo, paramsAjustado, ID_MODULO_INFO_JUGADOR, parametros); 
                        }
    
                        break;
                    case "CLICK_MENU_MICUENTA":
                        if(idUser!==""){
                            let parametros=idUser;
                            definirModulo(0, idModulo, paramsAjustado, ID_MODULO_GESTION_MICUENTA, parametros); 
                        }
    
                        break;    
                    case "CLICK_MENU_CREA_CONFIGURA":
                        definirModulo(0, idModulo, paramsAjustado, ID_MODULO_ADMIN_CONFIGURACION, ""); 
    
                        break;                  
                    case "CLICK_LLAMADA_TELEFONICA":
                        if(infoTorneos[numTorneoSel][11].trim()!==""){
                            let ind=recuperarDatoLocal("indicativo");
                            let tel=infoTorneos[numTorneoSel][11];
                            if(ind!=="" && tel.length>7) openInNewTab("tel:+" + ind + tel); 
                        }
                        else{
                            ventanaMensaje=showMensajePantalla("SIN INFORMACIÓN","El Organizador del Torneo no tiene definido un número de teléfono de contacto.",setShowMensaje,null,"INFO","BAJA");
                        }
                        
                        break;
                    case "CLICK_ABRIR_WHATSAPP":
                        if(infoTorneos[numTorneoSel][11].trim()!==""){
                            let ind2=recuperarDatoLocal("indicativo");
                            let tel2=infoTorneos[numTorneoSel][11];
                            if(ind2!=="" && tel2.length>7) openInNewTab("https://wa.me/" + ind2 + tel2);  
                        }
                        else{
                            ventanaMensaje=showMensajePantalla("SIN INFORMACIÓN","El Organizador del Torneo no tiene definido un número de teléfono de contacto.",setShowMensaje,null,"INFO","BAJA");
                        }
                        
                        break;
                    case "CLICK_ENVIAR_EMAIL":
                        if(infoTorneos[numTorneoSel][12].trim()!==""){
                            let correo=infoTorneos[numTorneoSel][12];
                            if(correo!=="" && esformatoEmail(correo)) openInNewTab("mailto:" + correo);
                        }
                        else{
                            ventanaMensaje=showMensajePantalla("SIN INFORMACIÓN","El Organizador del Torneo no tiene definido un email de contacto.",setShowMensaje,null,"INFO","BAJA");
                        }  
                        
                        break;
                    case "ABRIR_MODAL_CONTACTOMG":
                        setShowContactoMG(true);
    
                        break;
                    case "ENVIAR_MENSAJE_CONTACTO":
                        BD_solicitarDatos("ENVIAR_MENSAJE_CONTACTO", params);
    
    
                        break;
                    case "ABRIR_MODULO_MENSAJES":
                        parametros="";
                        definirModulo(0, idModulo, paramsAjustado, ID_MODULO_INFO_MENSAJES, parametros); 
        
                        break;
                    case "CLICK_TORNEO_INFO":
                        parametros=infoTorneosO[params].idtorneo;
                        definirModulo(0, idModulo, paramsAjustado, ID_MODULO_DETALLE_TORNEO, parametros); 
        
                        break;
                    case "CLICK_TORNEO_CONFIG":                        
                        parametros=infoTorneosO[params].idtorneo;
                        definirModulo(0, idModulo, paramsAjustado, ID_MODULO_ADMIN_TORNEO, parametros); 
        
                        break;
                    case "CLICK_NUEVO_TORNEO":                        
                        definirModulo(0, idModulo, paramsAjustado, ID_MODULO_ADMIN_TORNEO, "-1"); 
        
                        break;
                    case "SELECCIONAR_PARTIDO":

                        listaFechas=listaPartidosUS[params[0][0]];
                        listaTorneos=listaFechas[2][params[0][1]];
                        listaPartidos=listaTorneos[2][params[0][2]];

                        if(infoCampoSel===listaPartidos.idpartido && params[1]===true) {
                            setInfoCampoSel("-1");
                        }
                        if(infoCampoSel===listaPartidos.idpartido && params[1]===false){
                            setInfoCampoSel(listaPartidos.idpartido);
                        } 

                        if(infoCampoSel!==listaPartidos.idpartido) {
                            setInfoCampoSel(listaPartidos.idpartido);
                        }
                        break;
                    case "CLICK_OPCION_PARTIDO":
                        listaFechas=listaPartidosUS[params[0][0]];
                        listaTorneos=listaFechas[2][params[0][1]];
                        listaPartidos=listaTorneos[2][params[0][2]];

                        if(params[1]==="CLICK_VER_DETALLE")
                            definirModulo(0, idModulo, paramsAjustado, ID_MODULO_DETALLE_PARTIDO, listaPartidos.idpartido);
                        else{
                            ventanaMensaje=showMensajePantalla(params[1],"Funcionalidad en DESARROLLO",setShowMensaje,null,"ALERTA","BAJA");
                        }   

                        break;
                    case "CLICK_SELECCIONAR_ROL":
                                        closeRoles();
                    
                                        let i_sel=valorNumero(params[1]);
                    
                                            try{
                                                guardarDatoLocal("zonahoraria",infoUsuarioO[i_sel].zonaHorariaTF);
                                                guardarDatoLocal("telefono",infoUsuarioO[i_sel].zonaHorariaTel);
                                                guardarDatoLocal("nom_zonahoraria",infoUsuarioO[i_sel].zonaHorariaNombre);
                                                guardarDatoLocal("indicativo",infoUsuarioO[i_sel].indicativo);
                    
                                            }catch(err){
                                                presentarError(nomClase, nomFuncion,"",err);
                                            }
                    
                                            if(infoUsuarioO[i_sel].nombreRol.toLowerCase()==="jugador"){
                                                //if(idRol!=="4") idTorneoNotificacion="";
                                                idUser=infoUsuarioO[i_sel].idusuario;
                                                tipoUser=infoUsuarioO[i_sel].nombreRol;
                                                ingresoJugador(infoUsuarioO[i_sel].idasociado);
                                            }
                                            else if(infoUsuarioO[i_sel].nombreRol.toLowerCase()==="arbitro"){
                                                //if(idRol!=="3") idSedeNotificacion="";
                                                idUser=infoUsuarioO[i_sel].idusuario;
                                                tipoUser=infoUsuarioO[i_sel].nombreRol;
                                                //ingresoArbitro(infoUsuario[i_sel][2],infoUsuario[i_sel][6]);
                                                //alert("Rol ARBITRO no implementado, descargue la app para Android");

                                                let txtTitulo="Funcionalidad NO DISPONIBLE para Arbitros";
                                                let txtMensaje="Actualmente MarcaGol Web NO tiene acceso para Arbitros. Para Arbitros es necesario instalen la aplicación Android desde el PlayStore";
                                                
                                                ventanaMensaje=showMensajePantalla(txtTitulo,txtMensaje,setShowMensaje,null,"NORMAL","");
                                                //guardarDatoLocal("password","");
                                              
                                            }
                                            else if(infoUsuarioO[i_sel].nombreRol.toLowerCase()==="administrador"){
                                                idUser=infoUsuarioO[i_sel].idusuario;
                                                tipoUser=infoUsuarioO[i_sel].nombreRol;
                                                ingresoAdmin(infoUsuarioO[i_sel].idsede);
                                                //alert("Rol ADMINISTRADOR no implementado, descargue la app para Android");
                                                //guardarDatoLocal("password","");
                                                //presentarMensaje("", "Acceso Exclusivo JUGADORES 2", "Actualmente MarcaGol Web tiene acceso exclusivo para Jugadores y Espectadores. Para Organizadores o Arbitros es necesario instalen la aplicación Android desde el PlayStore")
                                                
                                            }
                    
                                        break;
                    default:
                        break;
                  }
            }
            
            
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }  
    } 


    const salir = () => {       
        definirModulo(0, 0, "", ID_MODULO_BASE, "");
    }

    const cambiarSede = (selectedOption, b) => {
        let nomFuncion="cambiarSede"; 

        try{

            let position=0;
            let valor="";

           
            if(selectedOption!==null) {
                position=selectedOption.index;
                valor=selectedOption.value;

                setSedeSelUS(position);
                idSede=valor;
                guardarDatoLocal("idSede",idSede);
                guardarDatoLocal("indicativo",infoSedesO[position][3]);

                guardarDatoLocal("nomEmpresa",infoSedesO[position][1]);
                guardarDatoLocal("nomSede",infoSedesO[position][2]);
            }        
            
            
            cargarTorneos();
            cargarPartidos();
            cargarPanelControl();   

            if(pestanaSelUS===1) setIrHastaHoy(true);
           

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }
    }


    const cargarTorneos = () => {
        let nomFuncion="cargarTorneos"; 

        try{
            let tempTorneos=[];

            for(let i=0;i<infoTorneosO.length;i++){
                if(infoTorneosO[i].idsede===idSede){
                    tempTorneos.push(infoTorneosO[i]);
                }
            }
            
            setListaTorneosUS(tempTorneos);           

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }
    }

    const cargarPartidos = () => {
        let nomFuncion="cargarPartidos"; 

        try{

            let tempFechas=[];
            let tempTorneos=[];
            let tempPartidos=[];

            let fecha="";
            let fechaActual="";
            let torneo="";
            let contFechas=0;
            let contTorneos=0;
            let hayDatosFechas=false;
            let textoFecha="";
            let hayPartidoHoy=false;
            let esFechaHoy=false;
            let contadorFecha=0;

            for(let i=0;i<infoPartidosO.length;i++){
                fechaActual=infoPartidosO[i].fechaActual;

                
                if(infoPartidosO[i].idsede===idSede){
                    
                    
                    if(fecha!==infoPartidosO[i].fechaPartido){   
                        
                        if(tempPartidos.length>0){
                            let idxTorneo=buscarTorneo(torneo);
                            let escudo=ic_torneo;
                            let nomTorneo="";
                            if(idxTorneo>=0){
                                if(infoTorneosO[idxTorneo].escudo!=="") escudo=ruta +  infoTorneosO[idxTorneo].escudo;
                                nomTorneo=infoTorneosO[idxTorneo].nombre;
                            }
                            tempTorneos.push([torneo,idxTorneo,tempPartidos,escudo,nomTorneo]);
                            torneo="";
                            tempPartidos=[];  
                        }

                        if(tempTorneos.length>0){                          
                            tempFechas.push([fecha,textoFecha,tempTorneos, esFechaHoy]);
                            esFechaHoy=false;
                            tempTorneos=[];
                            tempPartidos=[];  
                        }

                        fecha=infoPartidosO[i].fechaPartido;
                        
                        textoFecha=nombreFecha(infoPartidosO[i].fechaPartido, infoPartidosO[i].fechaActual);  
                        if(textoFecha==="Hoy"){
                            hayPartidoHoy=true; 
                            esFechaHoy=true;   
                        } 

                        if(esMayorHoy && !hayPartidoHoy){
                            tempTorneos.push(["-1",-1,[],ic_transparente,"No hay partidos programados para hoy"]);
                            torneo="";
                            tempFechas.push([fechaActual,"Hoy",tempTorneos, true]);
                            esFechaHoy=false;
                            hayPartidoHoy=true;
                            tempTorneos=[];
                            tempPartidos=[];  
                        }
                        
                        torneo=infoPartidosO[i].idtorneo;
                        tempPartidos.push(infoPartidosO[i]);                       
                            
                    }
                    else{
                        if(torneo!==infoPartidosO[i].idtorneo){
                            if(tempPartidos.length>0){
                                let idxTorneo=buscarTorneo(torneo);
                                let escudo=ic_torneo;
                                let nomTorneo="";
                                if(idxTorneo>=0){
                                    if(infoTorneosO[idxTorneo].escudo!=="") escudo=ruta +  infoTorneosO[idxTorneo].escudo;
                                    nomTorneo=infoTorneosO[idxTorneo].nombre;
                                }
                                tempTorneos.push([torneo,idxTorneo,tempPartidos,escudo,nomTorneo]);
                                torneo="";
                                tempPartidos=[];  
                            }

                            tempPartidos.push(infoPartidosO[i]);
                            torneo=infoPartidosO[i].idtorneo;
                            let nomTorneo="";
                        }
                        else{
                            tempPartidos.push(infoPartidosO[i]);
                        }
                    }

                    
                }
            }

            if(tempPartidos.length>0){
                let idxTorneo=buscarTorneo(torneo);
                let escudo=ic_torneo;
                let nomTorneo="";
                if(idxTorneo>=0){
                    if(infoTorneosO[idxTorneo].escudo!=="") escudo=ruta +  infoTorneosO[idxTorneo].escudo;
                    nomTorneo=infoTorneosO[idxTorneo].nombre;
                }
                tempTorneos.push([torneo,idxTorneo,tempPartidos,escudo,nomTorneo]);    

                if(textoFecha==="Hoy") {
                    tempFechas.push([fecha,textoFecha,tempTorneos, true]);
                    hayPartidoHoy=true;
                }
                else tempFechas.push([fecha,textoFecha,tempTorneos, false]);

                tempTorneos=[];


                if(!hayPartidoHoy){
                            tempTorneos.push(["-1",-1,[],ic_transparente,"No hay partidos programados para hoy"]);
                            torneo="";
                            tempFechas.push([fechaActual,"Hoy",tempTorneos, true]);
                }

            }                 
            
            

            
            setListaPartidosUS(tempFechas);   
            

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }
    }


    const cargarPanelControl = () => {
        let nomFuncion="cargarPanelControl"; 

        try{

            let tempPanel=[];

            let Phoy=0, Ptdias=0, Psdias=0;
            let AAhoy=0, AAtdias=0, AAsdias=0;

            let pj1=0, pj2=0, pj3=0;
            let pp1=0, pp2=0, pp3=0;

            let esArbitroPrincipal=true;
            //Presentar las tareas Pendientes
            if(infoPartidos.length>0){
                for(let i=0;i<infoPartidos.length;i++) {

                    let presentar = false;
                    if(infoPartidos[i][32]===idSede){
                        presentar=true;
                    }

                    if(presentar){
                        let estaActivo=false;
                        let comp1="", hora1="";

                        if(infoPartidos[i][31]==="1") estaActivo=true;

                        let isEst= valorNumero(infoPartidos[i][20]);
                        let dias= valorNumero(operacionFechas(4,infoPartidos[i][13],infoPartidos[i][22]));

                        comp1=operacionFechas(3,infoPartidos[i][13],infoPartidos[i][22]);
                        if(comp1!=="1"){

                            if((isEst==1) && estaActivo){
                                let arbitroDefecto=traerInfoTorneo(infoPartidos[i][0]);
                                if(infoPartidos[i][38]===(arbitroDefecto[2])) {
                                    if(dias<=1) AAhoy++;
                                    else if(dias<=3) AAtdias++;
                                    else if(dias<=7) AAsdias++;
                                }
                            }

                            if(!estaActivo) {
                                if(dias<=1) Phoy++;
                                else if(dias<=3) Ptdias++;
                                else if(dias<=7) Psdias++;
                            }

                            if((isEst<=4 || isEst==11) && estaActivo){
                                if (dias <= 1) pp1++;
                                else if (dias <= 3) pp2++;
                                else if (dias <= 7) pp3++;
                            }



                        }

                        if((isEst==5 || isEst==9 || isEst==10)){
                            if(dias<=3) pj1++;
                            else if(dias<=7) pj2++;
                            else if(dias<=15) pj3++;
                        }

                    }

                }
            }
            

            //Mis tareas pendientes [0]
            tempPanel.push([Phoy, Ptdias, Psdias, AAhoy, AAtdias, AAsdias]);

            //Información de partidos [1]
            tempPanel.push([pj1, pj2, pj3, pp1, pp2, pp3]);

            //Calificación de jugadores [2]
            let tieneCalificaciones=false;
            for(let i=0;i<infoCalificacionesO.length;i++){
                if(infoCalificacionesO[i].idsede===idSede){
                    tempPanel.push(infoCalificacionesO[i]);
                    i=infoCalificacionesO.length;
                    tieneCalificaciones=true;
                }
            }

            if(!tieneCalificaciones){
                let registro=Object.assign({} , calificacion);
                tempPanel.push(registro);
            }

            //Datos de mi Sede [3]
            let tieneCifras=false;
            for(let i=0;i<infoCifrasSedeO.length;i++){
                if(infoCifrasSedeO[i].idsede===idSede){
                    tempPanel.push(infoCifrasSedeO[i]);
                    i=infoCifrasSedeO.length;
                    tieneCifras=true;
                }
            }

            if(!tieneCifras){
                let registro=Object.assign({} , cifra);
                tempPanel.push(registro);
            }
            
            setListaPanelControlUS(tempPanel);           


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }
    }


    const traerInfoTorneo = (idT) => {
        let nomFuncion="traerInfoTorneo";

        let dato= ["","",""];
        try{
            if(infoTorneos.length>0){
                let i;
                for(i=0;i<infoTorneos.length;i++){
                    if(infoTorneos[i][0]===idT){
                        dato[0]=infoTorneos[i][2];
                        dato[1]=infoTorneos[i][1];
                        dato[2]=infoTorneos[i][6];
                        i=infoTorneos.length;
                    }
                }

            }

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }
        return  dato;
    }

    const buscarTorneo = (idT) => {
        let nomFuncion="buscarTorneo";

        let respuesta=-1;
        try{
            if(infoTorneosO.length>0){
                let i;
                for(i=0;i<infoTorneosO.length;i++){
                    if(infoTorneosO[i].idtorneo===idT){
                        respuesta=i;
                        i=infoTorneos.length;
                    }
                }

            }

        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }
        return  respuesta;
    }

    const nombreFecha = (fechaPartido, fechaActual) => {
        let nomFuncion="nombreFecha";

        let respuesta="";
        try{
            esMayorHoy=false;

            let comp1=operacionFechas(3, fechaPartido, fechaActual);
                            if(comp1===("3")){
                                respuesta="Hoy";
                            }
                            else if(comp1===("1")){
                                let fechaT=operacionFechas(1,fechaPartido,"1");
                                comp1=operacionFechas(3,fechaT, fechaActual);
                                if(comp1===("3")) respuesta="Ayer";
                                else respuesta=formatearFecha(fechaPartido,9);
                            }
                            else{
                                esMayorHoy=true;
                                let fechaT=operacionFechas(1,fechaPartido,"-1");
                                comp1=operacionFechas(3,fechaT, fechaActual);
                                if(comp1===("3")) respuesta="Mañana";
                                else respuesta=formatearFecha(fechaPartido,9);
                            }


        }catch(err){
            reportarError( nomClase, nomFuncion, "", err);
        }
        return  respuesta;
    }

    const ingresoJugador = (idJugador)  => {
            let nomFuncion="ingresoJugador";
    
            try{
    
                
    
                if(tieneRoles){
                    guardarDatoLocal("tieneRoles","1");
                    guardarDatoLocal("infoUsuario",infoUsuarioO);
                } 
                else {
                    guardarDatoLocal("tieneRoles","0");
                    guardarDatoLocal("infoUsuario","");
                }
    
                guardarDatoLocal("idUser",idUser);
                //guardarDatoLocal("tipoUser",tipoUser);
    
                definirModulo(0,idModulo,"",ID_MODULO_PRINCIPAL_JUGADOR,idUser);
                //guardarDatoLocal("tipoUser","jugador");
                //definirModulo(0,idModulo,"",ID_MODULO_PRINCIPAL_ADMIN,idUser);
    
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            } 
    
    }
        
    const ingresoAdmin = (idSede)  => {
            let nomFuncion="ingresoAdmin";
    
            try {
    
                if(tieneRoles){
                    guardarDatoLocal("tieneRoles","1");
                    guardarDatoLocal("infoUsuario",infoUsuarioO);
                } 
                else {
                    guardarDatoLocal("tieneRoles","0");
                    guardarDatoLocal("infoUsuario","");
                }
    
                guardarDatoLocal("idSede",idSede);
                guardarDatoLocal("idUser",idUser);
                //guardarDatoLocal("tipoUser",tipoUser);
    
                definirModulo(0,idModulo,"",ID_MODULO_PRINCIPAL_ADMIN,idUser);
    
            }catch(err){
                reportarError( nomClase, nomFuncion, "", err);
            } 
    
    }


    const analizarNotificaciones = () => {

        let browserSoportado = recuperarDatoLocal("browserSoportado");
        if(browserSoportado==="1"){
            let permiso = recuperarDatoLocal("tienePermisoNotificaciones");
            if(permiso!==""){
                if(superaTiempoDefinido("ultGuardar_PERMISO_NOTIFIC", 7)  || permiso==="0"){
                    requestPermission();
                }
                else{
                    if(permiso==="-1"){
                        if(superaTiempoDefinido("ultGuardar_MENSAJE_NOTIFIC", 7)){
                            guardarDatoLocal("ultGuardar_MENSAJE_NOTIFIC",Date.now());
                            let msj="Las Notificaciones son el mecanismo con el que MarcaGol puede mantenerlos informados acerca de sus torneos, partidos, etc.\n\nRecomendamos que habilite manualmente el permiso para las notificaciones con el fin de mantenerlo informado.";
                            ventanaMensaje=showMensajePantalla("Notificaciones NO HABILITADAS",msj,setShowMensaje,null,"ALERTA","");  
                        }
                         
                    }
                    if(permiso==="1"){
                        let tokenequipo= recuperarDatoLocal("tokenequipo");
                        let tokenenviado= recuperarDatoLocal("tokenenviado");
                        let iduserguardado= recuperarDatoLocal("iduserguardado");
    
                        if(tokenequipo!=="" && (tokenequipo!==tokenenviado || iduserguardado!==idUser)){                        
                            BD_solicitarDatos("GUARDAR_TOKEN",[tokenequipo,idUser]);
                        }
                    }
                }
            }
            

        }
        else{
            if(browserSoportado==="0"){
                if(superaTiempoDefinido("ultGuardar_BROWSER_NOSOPORTADO", 30)){
                    guardarDatoLocal("ultGuardar_BROWSER_NOSOPORTADO",Date.now());
                    let msj="El Explorador utilizado para acceder a MarcaGol NO SOPORTA el envio de Notificaciones.\n\nRecomendamos utilizar un explorador diferente para tener todas las funcionalidades.";
                    ventanaMensaje=showMensajePantalla("BROWSER NO SOPORTADO",msj,setShowMensaje,null,"ALERTA","");  
                }
            }
        }
        

    }

    const ScrollHastaHoy = () => {
        const elementRef = useRef();
        useEffect(() => {
            elementRef.current.scrollIntoView();
            let newScrollYPosition = window.pageYOffset;

            if(msjNoLeidosUS>0) newScrollYPosition=newScrollYPosition-160;
            else newScrollYPosition=newScrollYPosition-130;

            setIrHastaHoy(false);

            window.scrollTo({
                top: newScrollYPosition, // Posición vertical deseada
                left: 0
            });
        });

        return <div ref={elementRef}/>;
    };

    const ScrollHastaInicio = () => {
        const elementRef = useRef();
        useEffect(() => {
            elementRef.current.scrollIntoView(); 

            window.scrollTo({
                top: 0, // Posición vertical deseada
                left: 0,
                behavior: 'smooth' // Desplazamiento suave
            });
        });

        return <div ref={elementRef}/>;
    };

    
    return (
        <>
            {isOpenMenuFlotante && (
                <MenuFlotante isOpen={isOpenMenuFlotante} closeModal={closeMenuFlotante} >
                <div style={{margin:"4px"}}>
                    {listaRolesUser.length>0 && (
                        <div className='MD_ItemMenuFlotante' onClick={() => {openRoles();}}>
                                    <img src={ic_sombrero} className="IM_imgIcono24" alt=""/>
                                    <div className='TX_unaSolaLinea2' style={{padding:"8px"}}>Cambiar de Rol</div>
                        </div>
                    )}

                    {/*<div className='MD_ItemMenuFlotante'>
                                    <img src={ic_sombrero} className="IM_imgIcono24" alt=""/>
                                    <div className='TX_unaSolaLinea2' style={{padding:"8px"}}>Cambiar de Rol</div>
                    </div>*/}
                    <div className='MD_ItemMenuFlotante' onClick={() => clickGenerico("CLICK_MENU_MIINFORMACION")}>
                                    <img src={ic_mi_informacion} className="IM_imgIcono24" alt=""/>
                                    <div className='TX_unaSolaLinea2' style={{padding:"8px"}}>Mi Información</div>
                    </div>
                    <div className='MD_ItemMenuFlotante' onClick={() => clickGenerico("CERRAR_SESION")}>
                                    <img src={ic_salir_negro} className="IM_imgIcono24" alt=""/>
                                    <div className='TX_unaSolaLinea2' style={{padding:"8px"}}>Cerrar Sesión</div>
                    </div>
                                
                </div> 
                </MenuFlotante>
            )}
            
            {isOpenMenuLateral && (
                <MenuLateral isOpen={isOpenMenuLateral} closeModal={closeMenuLateral} >
                <>
                <div  style={{display:"flex", minWidth:"200px", maxWidth:"75vw", height:"190px"}}>
                    <div className='CT_imagenFondoMenu'   style={{width:"100%", display:"block", justifyContent:"center"}}>
                            <div style={{marginTop:"30px", marginInline:"10px", maxWidth:"75vw", flexGrow:"1", flexShrink:"1", display:"flex", justifyContent:"right"}}><img src={ic_logo_mg} height="70px"/></div>
                            <div><span style={{marginBlock:"4px", marginInline:"10px", color: C_colorAccent , fontSize: "14px", flexGrow:"1", flexShrink:"1", display:"flex", justifyContent:"right"}}>Vive Tú Afición Como Un Profesional</span></div>
                            <div><span style={{marginBlock:"4px", marginInline:"10px", color:C_uniformeBlanco, fontSize: "14px", flexGrow:"1", flexShrink:"1", display:"flex", justifyContent:"right"}}>contacto@marcagol.net</span></div>
                    </div>
                </div>

                <div style={{margin:"4px", paddingBottom:"100px"}}>
                    <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} onClick={() => clickGenerico("CLICK_MENU_MICUENTA")}>
                                    <img src={ic_jugadorsinimagen_gris} className="IM_imgIcono24" alt=""/>
                                    <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Mi Cuenta</div>
                    </div>
                    <div className='BF_lineaInferior'></div>  


                    <div style={{padding:"16px", textAlign:"left", fontSize:"16px", fontWeight:"bold", color:"gray"}}>Administra Tú Cancha</div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} onClick={() => clickGenerico("CLICK_MENU_CREA_CONFIGURA")}>
                            <img src={ic_configura_gris} className="IM_imgIcono24" alt=""/>
                            <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Crea y Configura</div>
                        </div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} >
                            <img src={ic_gestion_recursos} className="IM_imgIcono24" alt=""/>
                            <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Gestiona Tus Recursos</div>
                        </div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} >
                            <img src={ic_estadisticas} className="IM_imgIcono24" alt=""/>
                            <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Reportes y Estadísticas</div>
                        </div>
                
                    
                    <div className='BF_lineaInferior'></div> 

                    <div style={{padding:"16px", textAlign:"left", fontSize:"16px", fontWeight:"bold", color:"gray"}}>Gestiona Tus Torneos</div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} >
                            <img src={ic_calendario_gris} className="IM_imgIcono24" alt=""/>
                            <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Programa Partidos</div>
                        </div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} >
                            <img src={ic_tarjeta_dobleamarilla} className="IM_imgIcono24" alt=""/>
                            <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Gestiona Sanciones</div>
                        </div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} >
                            <img src={ic_cobros_recibir} className="IM_imgIcono24" alt=""/>
                            <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Gestiona Cobros - Pagos</div>
                        </div>
                
                    
                    <div className='BF_lineaInferior'></div>

                    <div style={{padding:"16px", textAlign:"left", fontSize:"16px", fontWeight:"bold", color:"gray"}}>Mensajes</div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} onClick={() => clickGenerico("ABRIR_MODULO_MENSAJES")}>
                                        <img src={ic_mensaje_negro} className="IM_imgIcono24" alt=""/>
                                        <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Bandeja Entrada</div>
                        </div>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}}>
                                        <img src={ic_enviarinformacion} className="IM_imgIcono24" alt=""/>
                                        <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Bandeja Salida</div>
                        </div>

                    <div className='BF_lineaInferior'></div>  


                    <div style={{padding:"16px", textAlign:"left", fontSize:"16px", fontWeight:"bold", color:"gray"}}>Contáctanos</div>
                    <a href='https://www.marcagol.net' target="_blank" style={{textDecoration:"none", color:"black"}}>
                        <div className='MD_ItemMenuFlotante' style={{padding:"16px"}}>
                            <img src={ic_sitio_web} className="IM_imgIcono24" alt=""/>                        
                            <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>MarcaGol.net</div>  
                        </div>
                    </a>
                    <div className='MD_ItemMenuFlotante' style={{padding:"16px"}} onClick={() => clickGenerico("ABRIR_MODAL_CONTACTOMG")}>
                        <img src={ic_responder_gris} className="IM_imgIcono24" alt=""/>
                        <div className='TX_unaSolaLinea2' style={{marginLeft:"20px"}}>Soporte MarcaGol</div>
                    </div>
                    
                    

                </div> 

                </>
                
                </MenuLateral>
            )}
            
            {isOpenPublicidad && infoMensajeO.length>0 && (
                <Modal isOpen={isOpenPublicidad} closeModal={closePublicidad}  titulo={""} txtAceptar='' txtCancelar='' isCancelable={false}>
                <div className="BF_bordeTotal" style={{paddingInline:"10px", paddingBottom:"20px", paddingTop:"10px", marginTop:"0px", marginBottom:"20px", marginInline:"10px", minWidth:"250px", maxWidth:"500px"}}>

                    <div style={{textAlign:"left", fontSize:"16px", color:C_uniformeNegro, fontWeight:"bold"}}>{infoMensajeO[0].titulo}</div>

                    {infoMensajeO[0].textoini!=="" && (
                        <div style={{textAlign:"left", fontSize:"14px", color:C_uniformeGrisOscuro, marginTop:"20px", whiteSpace:"pre-wrap"}}>{infoMensajeO[0].textoini}</div>
                    )}
                    
                    {infoMensajeO[0].imagen!=="" && (
                    <div style={{marginTop:"20px", marginInline:"10px", display:"flex", alignItems:"start"}}>
                        <img src={ruta + infoMensajeO[0].imagen} style={{minWidth:"250px", maxWidth:"400px", border:"0px solid green"}} alt=""/>
                    </div>
                    )}

                    {infoMensajeO[0].textofin!=="" && (
                        <div style={{textAlign:"left", fontSize:"14px", color:C_uniformeGrisOscuro, marginTop:"20px", whiteSpace:"pre-wrap"}}>{infoMensajeO[0].textofin}</div>
                    )}
                    
                    {infoMensajeO[0].link!=="" && (
                        <div style={{marginTop:"30px"}}  >
                        <a href={infoMensajeO[0].link} target="_blank" style={{textDecoration:"none"}} >
                            <div style={{display:"flex", flexWrap:"nowrap", alignItems:"left", cursor:"pointer"}}  >
                                <img src={ic_manual_primary} className="IM_imgIcono24" alt=""/>
                                <div className='TX_unaSolaLinea2' style={{marginLeft:"20px", color:C_colorPrimary, textAlign:"left", fontWeight:"bold"}}>{(infoMensajeO[0].textolink!=="" ? (infoMensajeO[0].textolink) : (infoMensajeO[0].link))}</div>
                            </div>
                        </a>
                        </div>
                    )}                  

                    

                </div>  
                </Modal>
            )}

            {isOpenRoles && listaRolesUser.length>0 && (
                <Modal isOpen={isOpenRoles} closeModal={closeRoles}  titulo={"Cambiar tu ROL"}  isCancelable={true} txtAceptar="" txtCancelar=""  >
            
                            <div style={{margin:"10px", maxWidth:"400px"}}>
            
                                <div>
                                        <div style={{marginTop:"20px", fontSize:"14px", color:C_uniformeGrisOscuro}}>
                                            Selecciona el ROL que quieres utilizar. En cualquier momento podrás intercambiar tú ROL.
                                        </div>
            
                                        
                                        <div style={{marginBlock:"10px", marginInline:"10px"}}>
                                            {listaRolesUser ? (
                                                        listaRolesUser.map((reg, index) => (<Template_lista_roles key={index} datos={reg} indice={index} tipoLista={"LISTA_ROLES"} handleClick={clickGenerico}/> ) )
                                                    ) : (<tr><td>Sin Informacion</td></tr>)}     
                                        </div>
            
                                       
            
                                     </div>                  
                                
            
                            </div>              
                            
                        </Modal>
            )}
            


            {showContactoMG && (<ContactoMG datos={arrCampos} funcionExterna={clickGenerico} cerrar={() => setShowContactoMG(false)}  /> )}
            
          
            {showMensaje && (ventanaMensaje)}


            <div className={pestanaSelUS===2 ? ("CT_fondoVentanaBlanca") : ("CT_fondoVentana")}> </div> 

            <div className="CT_zonaFija">
                <div className="CT_encabezado">
                        <div className="CT_elementoEncabezado" onClick={() => {openMenuLateral()}}><img src={ic_menu} className="IM_imgIcono24" alt="" style={{padding: "8px", cursor:"pointer"}} />  </div>                    
                        <div className="CT_elementoEncabezado" style={{flexGrow:"1", flexShrink:"1", minWidth:"100px"}}><p className="TX_unaSolaLinea2" style={{textAlign:"left"}}>{"Panel de Control"}</p></div>
                        <div className="CT_elementoEncabezado"><img className="IM_imgIcono24" src={ic_mensaje_blanco} alt="" style={{padding: "4px", cursor:"pointer"}} onClick={() => clickGenerico("ABRIR_MODULO_MENSAJES")}/></div>
                        <div className="CT_elementoEncabezado" onClick={() => {openMenuFlotante()}}>
                            <img className="IM_imgIcono24" src={ic_jugadorsinimagen} alt="" style={{padding: "8px", cursor:"pointer"}}/>                            
                        </div>
                </div>   

                {msjNoLeidosUS>0 && (
                    <div style={{display:"flex", flexWrap:"nowrap", backgroundColor:C_colorAccent, color:C_uniformeNegro, fontSize:"14px"}}>
                        <div style={{flex:"1"}}></div>
                        <div style={{display:"flex", flexWrap:"nowrap", cursor:"pointer"}} onClick={() => clickGenerico("ABRIR_MODULO_MENSAJES")}>
                            <div className='TX_unaSolaLinea2' style={{marginBottom:"4px", marginTop:"4px"}}>{msjNoLeidosUS===1 ? ("Tienes " + msjNoLeidosUS + " Mensaje SIN leer.") : ("Tienes " + msjNoLeidosUS + " Mensajes SIN leer.")}</div> 
                            <img className="IM_imgIcono20"  src={ic_manual_blanco} alt="" style={{marginInline:"10px", marginBottom:"2px"}}/>
                            <div style={{marginBottom:"4px", marginTop:"4px", paddingRight:"25px"}}>Ver</div>
                        </div>
                    </div>  
                )}

                <div style={{background:C_colorPrimaryDark, width:"100%", display:"flex", flexWrap:"nowrap", padding:"4px", alignItems:"center"}}>
                        <img className="IM_imgIcono46" src={fotoUsuarioUS} alt="" style={{paddingInline: "4px"}}/>
                        <div style={{flex:"1"}}>
                            <div className='TX_unaSolaLinea2' style={{fontSize:"12px", textAlign:"left"}}><span style={{color:C_colorAccent, marginInline:"10px"}}>Administrador:</span> <span style={{color:C_uniformeBlanco, fontWeight:"bold"}}>{nomUsuarioUS}</span></div>
                            <div>
                                {selSedesUS.length>1 &&  (   
                                    <div style={{backgroundColor:"white", paddingBottom:"0px", marginBottom:"4px", marginInline:"6px"}}>           
                                    <Select     
                                        styles={estilosSelect}
                                        defaultValue={selSedesUS[sedeSelUS]}
                                        formatOptionLabel={listaIconoDosItems}
                                        options={selSedesUS}
                                        isSearchable={false}   
                                        onChange={(e,index) => {cambiarSede(e,index)}}         
                                    />   
                                    </div>                 
                                )}
                                {selSedesUS.length<=1 && (
                                    <>
                                    <div className='TX_unaSolaLinea2' style={{fontSize:"12px", textAlign:"left"}}><span style={{color:C_colorAccent, marginInline:"10px"}}>Empresa:</span> <span style={{color:C_uniformeBlanco}}>{nomEmpresaUS}</span></div>
                                    <div className='TX_unaSolaLinea2' style={{fontSize:"12px", textAlign:"left"}}><span style={{color:C_colorAccent, marginInline:"10px"}}>Sede:</span> <span style={{color:C_uniformeBlanco}}>{nomSedeUS}</span></div>
                                    </>
                                )}
                            </div>
                            
                        </div>
                </div>  
                
                
                            
                     
            </div>    

            
            <div style={{position: "relative"}}>  
                

                {pestanaSelUS===2 && (
                    <div style={{paddingTop: (msjNoLeidosUS>0 ? ("160px") : ("140px")), paddingInline:"10px", paddingBottom:"60px"}}>
                        <ScrollHastaInicio /> 
                        <div  style={{display:"flex", justifyContent:"left", alignItems:"center"}} >
                            <img className="IM_imgRedondeada28" src={ic_torneo} alt="" />
                            <div style={{flex:"1", fontSize:"16px", textAlign:"left", marginLeft:"10px"}}>Torneos Activos de la sede</div>                             
                        </div>  
                        <div style={{display:"flex"}}>
                            <div style={{flex:1}}></div>
                            <div  style={{display:"flex", justifyContent:"center", alignItems:"center", margin:"10px", padding:"10px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_NUEVO_TORNEO")}}>
                                <img className="IM_imgIcono28" src={ic_nuevo_primary} alt="" />
                                <div style={{fontSize:"16px", textAlign:"left", marginLeft:"10px", color:C_colorPrimary}}>Crear Nuevo Torneo</div>                             
                            </div> 
                            <div style={{flex:1}}></div>
                        </div>
                        {listaTorneosUS.length>0 && (
                            <div style={{maxWidth:"600px", minWidth:"300px"}}>
                            {(listaTorneosUS.map((reg, index) => (<DinamicoElementosTorneo key={index} registro={reg.index} numRegistro={index+1} tipoLista={"TORNEOS_PRINCIPAL_ADMIN"} datos={reg} modOrigen={idModulo} paramOrigen={paramsAjustado} modDestino={ID_MODULO_DETALLE_TORNEO} paramDestino={reg.idtorneo} definirModulo={clickGenerico} incluirLinea={false}  />))  )}
                            </div>
                        )}
                        
                        {listaTorneosUS.length===0 && (
                            <div style={{color:C_uniformeGrisOscuro, marginTop:"100px"}}>
                                {"Actualmente la Sede no tiene torneos Activos."}
                            </div>
                        )}
                    </div>
                )}

                {pestanaSelUS===1 && (
                    <div style={{paddingTop: (msjNoLeidosUS>0 ? ("160px") : ("130px")), paddingBottom:"60px"}}>
                        {listaPartidosUS.length>0 && 
                        (<>
                            {listaPartidosUS.map((fecha, index) => (<div key={fecha[0]} >
                                {fecha[3]===true && irHastaHoy && (<ScrollHastaHoy />)}
                                <div className='BF_cajaBlanca' style={{marginBottom:"20px", marginInline:"4px"}}>
                                    <div  style={{display:"flex", justifyContent:"left", alignItems:"center", padding:"10px"}}>
                                        <div style={{flex:"1", fontSize:"20px", fontWeight:"bold", textAlign:"left", marginInline:"10px", marginBlock:"5px", color:C_uniformeGrisOscuro}}>{fecha[1]}</div> 
                                    </div>

                                    {fecha[2].length>0 && 
                                    (<>
                                        {fecha[2].map((torneo, index2) => (
                                            <div key={torneo[0]} style={{display:"flex", flexWrap:"wrap", gap:"2px", marginBottom:"15px"}}>
                                                    <div className='BF_cajaGris' style={{flex:"1", minWidth:"300px", marginBottom:"2px", marginInline:"2px"}}>
                                                        <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"left", alignItems:"center"}}>
                                                            <img className="IM_imgRedondeada36" src={torneo[3]} alt="" style={{marginInline:"10px", marginBlock:"4px"}}/>
                                                            <div style={{flex:"1"}}><p className='TX_tituloCaja'>{torneo[4]}</p></div>
                                                            {torneo[0]!=="-1" && (<img className="IM_imgIcono16" src={ic_manual_primary} alt="" style={{padding:"8px", cursor:"pointer"}} onClick={() => {clickGenerico("CLICK_TORNEO_INFO",torneo[1])}}/>)}
                                                        </div>
                                                        
                                                        {torneo[2].length>0 && (
                                                        <div className='BF_cajaBlanca'>                            
                                                            <div className='CT_Admin_Partidos'>
                                                                {torneo[2].map((partido, index3) => (
                                                                        <DinamicoPartidosProgramados key={partido.idpartido} partido={partido} linea={showInfoAdicionalUS} tipoPartido="dpa"  paramOrigen={""} definirModulo={definirModulo} clickGenerico={clickGenerico} index={[index, index2, index3]} seleccionado={infoCampoSel===partido.idpartido ? (true) : (false)}/>                                                                        
                                                                ))}
                                                            </div>          
                                                        </div>
                                                        )}
                                                        
                                                    </div>                                         
                                            </div>
                                        ))}
                                    </>)}

                                </div>
                            </div>
                            ))}
                        </>)}
                    </div>
                )}

                {pestanaSelUS===0 && (
                    <div style={{paddingTop: (msjNoLeidosUS>0 ? ("160px") : ("125px")), paddingBottom:"60px"}}>
                        <ScrollHastaInicio /> 
                        <div style={{display:"flex", flexWrap:"wrap", gap:"12px", margin:"8px"}}>
                            
                            <div className='BF_cajaTareas' style={{flex:"1", flexGrow:"1", flexShrink:"1", minWidth:"300px"}}>
                                <div style={{padding:"10px"}}>
                                    <div style={{display:"flex", justifyContent:"left", alignItems:"center"}}>
                                        <img className="IM_imgIcono28" src={ic_tareas} alt="" />
                                        <div style={{flex:"1", fontSize:"16px", fontWeight:"bold", textAlign:"left", marginLeft:"10px"}}>Mis Tareas Pendientes</div> 
                                        <img className="IM_imgIcono20"  src={ic_manual_primary} alt=""/>
                                    </div>
                                    <div style={{color:C_uniformeGrisOscuro, fontSize:"22px", textAlign:"center"}}>
                                        <table border={0} width="100%">
                                            <tbody>
                                                <tr style={{fontSize:"12px", color:C_uniformeNegro}}><td width="40%">{""}</td><td width="20%" style={{color:C_colorAccent}}>{"1D"}</td><td width="20%">{"3D"}</td><td width="20%">{"7D"}</td></tr>
                                                <tr><td style={{textAlign:"left", color:C_uniformeNegro, fontSize:"16px"}}><span>{"Publicar Partidos"}</span></td>
                                                    <td style={{color:C_colorAccent, fontSize:"22px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[0][0]) : ("0")}</td>
                                                    <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[0][1]) : ("0")}</td>
                                                    <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[0][2]) : ("0")}</td></tr>
                                                <tr><td style={{textAlign:"left", color:C_uniformeNegro, fontSize:"16px"}}>{"Asignar Arbitros"}</td>
                                                    <td style={{color:C_colorAccent, fontSize:"22px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[0][3]) : ("0")}</td>
                                                    <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[0][4]) : ("0")}</td>
                                                    <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[0][5]) : ("0")}</td></tr>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>
                            </div>


                            <div className='BF_cajaBlanca' style={{flex:"1", flexGrow:"1", flexShrink:"1", minWidth:"300px", marginTop:"0px", marginLeft:"0px"}}>
                                <div  style={{display:"flex", justifyContent:"left", alignItems:"center", padding:"10px"}}>
                                    <img className="IM_imgIcono28" src={ic_partido_verde} alt="" />
                                    <div style={{flex:"1", fontSize:"16px", fontWeight:"bold", textAlign:"left", marginLeft:"10px"}}>Información de Partidos</div> 
                                    <img className="IM_imgIcono20"  src={ic_manual_primary} alt=""/>
                                </div>

                                <div style={{display:"flex", flexWrap:"wrap", gap:"2px", margin:"0px"}}>
                                    <div className='BF_cajaGris' style={{flex:"1", minWidth:"150px", maxWidth:"900px", marginBottom:"2px", marginInline:"2px"}}>
                                        <p className='TX_tituloCaja'>{"Realizados"}</p>
                                        <div className='BF_cajaBlanca'>                            
                                            <div style={{display:"flex", alignItems:"center", flexWrap:"nowrap", paddingLeft:"10px"}}>
                                                <img className="IM_imgIcono28" src={ic_silbato} alt="" />
                                                <div style={{flex:"1"}}>
                                                    <table width="100%" style={{textAlign:"center", fontSize:"18px", color:C_uniformeGrisOscuro}}><tbody>
                                                        <tr style={{fontSize:"12px", color:C_uniformeNegro}}><td style={{color:C_colorAccent}}>{"3D"}</td><td>{"7D"}</td><td>{"2S"}</td></tr>
                                                        <tr>
                                                            <td style={{color:C_colorAccent}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[1][0]) : ("0")}</td>
                                                            <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[1][1]) : ("0")}</td>
                                                            <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[1][2]) : ("0")}</td></tr>
                                                    </tbody></table>
                                                </div>
                                            </div>          
                                        </div>
                                    </div> 
                                    <div className='BF_cajaGris' style={{flex:"1", minWidth:"150px", maxWidth:"900px", marginBottom:"2px", marginInline:"2px"}}>
                                        <p className='TX_tituloCaja'>{"Programados"}</p>
                                        <div className='BF_cajaBlanca'>                            
                                            <div style={{display:"flex", alignItems:"center", flexWrap:"nowrap", paddingLeft:"10px"}}>
                                                <img className="IM_imgIcono28" src={ic_programar} alt="" />
                                                <div style={{flex:"1"}}>
                                                    <table width="100%" style={{textAlign:"center", fontSize:"18px", color:C_uniformeGrisOscuro}}><tbody>
                                                        <tr style={{fontSize:"12px", color:C_uniformeNegro}}><td style={{color:C_colorAccent}}>{"3D"}</td><td>{"7D"}</td><td>{"2S"}</td></tr>
                                                        <tr>
                                                            <td style={{color:C_colorAccent}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[1][3]) : ("0")}</td>
                                                            <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[1][4]) : ("0")}</td>
                                                            <td>{listaPanelControlUS.length>0 ? (listaPanelControlUS[1][5]) : ("0")}</td></tr>
                                                    </tbody></table>
                                                </div>
                                            </div>               
                                        </div>
                                    </div> 
                                </div> 

                            </div>
                        </div>

                        <div style={{display:"flex", flexWrap:"wrap", gap:"12px", margin:"8px", paddingTop:"4px", paddingBottom:"60px"}}>
                            
                            <div className='BF_cajaBlanca' style={{flex:"1", flexGrow:"1", flexShrink:"1", minWidth:"300px"}}>
                                <div  style={{display:"flex", justifyContent:"left", alignItems:"center", padding:"10px"}}>
                                    <img className="IM_imgIcono28" src={ic_estrella} alt="" />
                                    <div style={{flex:"1", fontSize:"16px", fontWeight:"bold", textAlign:"left", marginLeft:"10px"}}>Calificación de Jugadores</div> 
                                    
                                </div>
                                

                                <div className='BF_cajaGris' style={{flex:"1", minWidth:"150px", maxWidth:"900px", margin:"2px", marginBottom:"8px"}}>
                                        <p className='TX_tituloCaja' style={{paddingBlock:"2px"}}>{"Evaluación de los Arbitros"}</p>
                                        <div className='BF_cajaBlanca'>                            
                                            <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"center", alignItems:"center", color:C_uniformeNegro, textAlign:"center"}}>
                                                <div style={{flex:"1", fontSize:"32px", color:C_colorPrimary, fontWeight:"bold"}}>{listaPanelControlUS.length>0 ? (formatearDecimal(listaPanelControlUS[2].c_arbitro) ) : ("0")}</div>
                                                <div style={{flex:"1"}}>
                                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                                        <img className="IM_imgIcono20" src={ic_planilla} alt="" style={{marginInline:"6px"}}/>
                                                        <span style={{margin:"6px", fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (formatearDecimal(listaPanelControlUS[2].c1_arbitro)) : ("0")}</span>
                                                    </div>
                                                    <div style={{fontSize:"12px"}}>Reglamento</div>
                                                </div>
                                                <div style={{flex:"1"}}>
                                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                                        <img className="IM_imgIcono20" src={ic_ubicacion} alt="" style={{marginInline:"6px"}}/>
                                                        <span style={{margin:"6px", fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (formatearDecimal(listaPanelControlUS[2].c2_arbitro)) : ("0")}</span>
                                                    </div>
                                                    <div style={{fontSize:"12px"}}>Ubicación</div>
                                                </div>
                                                <div style={{flex:"1"}}>
                                                    <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                                        <img className="IM_imgIcono20" src={ic_gestion_recursos} alt="" style={{marginInline:"6px"}}/>
                                                        <span style={{margin:"6px", fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (formatearDecimal(listaPanelControlUS[2].c3_arbitro)) : ("0")}</span>
                                                    </div>
                                                    <div style={{fontSize:"12px"}}>Manejo</div>
                                                </div>
                                            </div>          
                                        </div>
                                    </div>
                                
                                <div className='BF_cajaGris' style={{flex:"1", minWidth:"150px", maxWidth:"900px", margin:"2px"}}>
                                        <p className='TX_tituloCaja' style={{paddingBlock:"2px"}}>{"Evaluación de la Cancha"}</p>
                                        <div className='BF_cajaBlanca'>                            
                                            <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"center", alignItems:"center", color:C_uniformeNegro, textAlign:"center"}}>
                                                <div style={{flex:"1", fontSize:"32px", color:C_colorPrimary, fontWeight:"bold"}}>{listaPanelControlUS.length>0 ? (formatearDecimal(listaPanelControlUS[2].c_sede)) : ("0")}</div>
                                                <div style={{flex:"3", display:"flex", flexWrap:"nowrap", justifyContent:"center", alignItems:"center"}}>
                                                    <div style={{flex:"1"}}>
                                                        <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                                            <img className="IM_imgIcono20" src={ic_partido_verde} alt="" style={{marginInline:"6px"}}/>
                                                            <span style={{margin:"6px", fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (formatearDecimal(listaPanelControlUS[2].c1_sede)) : ("0")}</span>
                                                        </div>
                                                        <div style={{fontSize:"12px"}}>Campo de Juego</div>
                                                    </div>
                                                    <div style={{flex:"1"}}>
                                                        <div style={{display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}}>
                                                            <img className="IM_imgIcono20" src={ic_empresa} alt="" style={{marginInline:"6px"}}/>
                                                            <span style={{margin:"6px", fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (formatearDecimal(listaPanelControlUS[2].c2_sede)) : ("0")}</span>
                                                        </div>
                                                        <div style={{fontSize:"12px"}}>Instalaciones</div>
                                                    </div>
                                                </div>
                                            </div>           
                                        </div>
                                    </div>

                                <div style={{display:"flex", flexWrap:"nowrap", justifyContent:"center", alignItems:"center", fontSize:"12px", marginBlock:"2px", marginInline:"8px"}}>
                                    <div>Partidos</div>
                                    <div style={{flex:"1", color:C_uniformeAzulClaro}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[2].num_partidos) : ("0")}</div>
                                    <div>Evaluaciones</div>
                                    <div style={{flex:"1", color:C_uniformeAzulClaro}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[2].num_evaluaciones) : ("0")}</div>
                                </div>

                            </div>


                            <div className='BF_cajaBlanca' style={{flex:"1", flexGrow:"1", flexShrink:"1", minWidth:"300px", marginTop:"0px", marginLeft:"0px"}}>
                                <div  style={{display:"flex", justifyContent:"left", alignItems:"center", padding:"10px"}}>
                                    <img className="IM_imgIcono28" src={ic_sedes} alt="" />
                                    <div style={{flex:"1", fontSize:"16px", fontWeight:"bold", textAlign:"left", marginLeft:"10px"}}>Datos de mi Sede</div> 
                                    <img className="IM_imgIcono20"  src={ic_manual_primary} alt=""/>
                                </div>

                                <div className='BF_cajaGris' style={{minWidth:"250px", maxWidth:"900px", marginBottom:"10px", marginInline:"4px"}}>
                                    <p className='TX_tituloCaja'>{"Recursos Activos de Mi Sede"}</p>
                                    <div className='BF_cajaBlanca'>                            
                                        <table width="100%" border={0} style={{textAlign:"center", fontSize:"16px", color:C_uniformeGrisOscuro}}><tbody>
                                            <tr>
                                                <td width="10%"><div style={{display:"flex", justifyContent:"center"}}><img className="IM_imgIcono24"  src={ic_torneo} alt=""/></div></td>
                                                <td width="10%" style={{color:C_colorAccent, fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[3].numTorneos) : ("0")}</td>
                                                <td width="30%">Torneos</td>
                                                <td width="10%"><div style={{display:"flex", justifyContent:"center"}}><img className="IM_imgIcono24"  src={ic_escudo_base2_w} alt=""/></div></td>
                                                <td width="10%" style={{color:C_colorAccent, fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[3].numEquipos) : ("0")}</td>
                                                <td width="30%">Equipos</td>
                                            </tr>    
                                            <tr height="40px">
                                                <td width="10%"><div style={{display:"flex", justifyContent:"center"}}><img className="IM_imgIcono24"  src={ic_jugador} alt=""/></div></td>
                                                <td width="10%" style={{color:C_colorAccent, fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[3].numJugadores) : ("0")}</td>
                                                <td width="30%">Jugadores</td>
                                                <td width="10%"><div style={{display:"flex", justifyContent:"center"}}><img className="IM_imgIcono24"  src={ic_silbato} alt=""/></div></td>
                                                <td width="10%" style={{color:C_colorAccent, fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[3].numArbitros) : ("0")}</td>
                                                <td width="30%">Arbitros</td>
                                            </tr> 
                                            <tr>
                                                <td width="10%"><div style={{display:"flex", justifyContent:"center"}}><img className="IM_imgIcono24"  src={ic_partido_verde} alt=""/></div></td>
                                                <td width="10%" style={{color:C_colorAccent, fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[3].numCanchas) : ("0")}</td>
                                                <td width="30%">Canchas</td>
                                                <td width="10%"><div style={{display:"flex", justifyContent:"center"}}><img className="IM_imgIcono24"  src={ic_balon_gol} alt=""/></div></td>
                                                <td width="10%" style={{color:C_colorAccent, fontSize:"18px"}}>{listaPanelControlUS.length>0 ? (listaPanelControlUS[3].numPartidos) : ("0")}</td>
                                                <td width="30%">Partidos</td>
                                            </tr> 
                                        </tbody></table>          
                                    </div>
                                </div> 

                                


                            </div>
                        </div>
                    </div>
                )}

            </div>

            <div className='CT_zonaFijaInferior' style={{display:"flex", flexWrap:"nowrap", alignItems:"center", padding:"8px", cursor:"pointer"}} >
                <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}} onClick={() => {setPestanaSelUS(0); paramsAjustado=idUser + "#0";}}>
                    <img src={pestanaSelUS===0 ? (ic_informacion_accent) : (ic_informacion_blanco)} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                    <span className='TX_unaSolaLinea2' style={pestanaSelUS===0 ? ({marginLeft:"8px", fontWeight:"bold", color:C_colorAccent}) : ({marginLeft:"8px", color:C_uniformeBlanco}) }>Control</span>
                </div>

                <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}} onClick={() => {setPestanaSelUS(1); paramsAjustado=idUser + "#1"; setIrHastaHoy(true); setInfoCampoSel("-1");}}>
                    <img src={pestanaSelUS===1 ? (ic_partido_accent) : (ic_partido)} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                    <span className='TX_unaSolaLinea2' style={pestanaSelUS===1 ? ({marginLeft:"8px", fontWeight:"bold", color:C_colorAccent}) : ({marginLeft:"8px", color:C_uniformeBlanco}) }>Partidos</span>
                </div>

                <div style={{flex:"1", display:"flex", flexWrap:"nowrap", alignItems:"center", justifyContent:"center"}} onClick={() => {setPestanaSelUS(2); paramsAjustado=idUser + "#2";}}>
                    <img src={pestanaSelUS===2 ? (ic_torneo_accent) : (ic_torneo_gris_w)} className="IM_imgIcono24" alt="" style={{margin:"0px", padding:"0px"}}/>
                    <span className='TX_unaSolaLinea2' style={pestanaSelUS===2 ? ({marginLeft:"8px", fontWeight:"bold", color:C_colorAccent}) : ({marginLeft:"8px", color:C_uniformeBlanco}) }>Torneos</span>
                </div>
                
            </div>

            {loading && <Loader tipo={"TOTAL"}/>}   

            {esError!==0 && <ShowError tipoError={esError} funcionCerrar={salir} />}
            
        </>
    );


};

export default Principal_Admin;